import { Component } from '@angular/core';
import { MatDialog, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/helpers/date-formats';
import { registerLocaleData, CommonModule } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';

import { StatsService } from 'src/app/core/services/stats.service';

registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@Component({
  selector: 'app-stats',
  templateUrl: './docs-by-nif.component.html',
  styleUrls: ['./docs-by-nif.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class DocsByNifComponent {

  loading: boolean;
  mostrarError: boolean;
  mostrarListado: boolean;

  datosInforme = []; //Para el listado de Numero de documentos por NIF

  constructor( private statsService: StatsService ) {
    this.loading = false;
    this.mostrarError = false;
    this.mostrarListado = false;
  }

  VisualizarDatos(nif: string) {

    this.loading = true;
    this.mostrarError = false;
    this.mostrarListado = false;

    this.datosInforme = [];  

    this.statsService.obtenerListadoNumFactNIF(nif).subscribe(datos => {
      this.datosInforme = datos;

      this.mostrarListado = true;
      this.loading = false;
    }, ( error ) => {
      this.loading = false;
      this.mostrarError = true;
    });
  }

  SumaLinea(index: number): number {
    return this.datosInforme[index].documentosEmitidas + this.datosInforme[index].documentosRecibidas;
  }


}
